import { useEffect, useState, useCallback } from "react";
import { statisticsService } from "features/statistics/services/statistics-service";
import type { Report } from "../types";

export const useFetchReport = (
  id: string,
  skipFetch?: boolean,
  newReport?: any,
): { report: Report | undefined; isLoading: boolean; error: any; refetch: () => void } => {
  const [report, setReport] = useState<Report>();
  const [isLoading, setIsLoading] = useState(() => (typeof skipFetch === "boolean" ? skipFetch : true));
  const [refetchIndex, setRefetchIndex] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (newReport) {
      try {
        setReport({
          name: "Preview, not submitted",
          content: newReport.report,
        });
      } catch (error_) {
        setError(error_);
        console.error(error_);
      }

      setIsLoading(false);
    }
  }, [id, skipFetch, newReport]);

  const refetch = useCallback(() => {
    setRefetchIndex(prevRefetchIndex => prevRefetchIndex + 1);
  }, []);

  useEffect((): any => {
    let abortController: AbortController | null;

    async function fetchData() {
      try {
        setIsLoading(true);
        setError(null);

        abortController = new AbortController();
        const response: Report = await statisticsService.getReport(id, abortController);

        setReport(response);
      } catch (error_) {
        setError(error_);
        setReport(undefined);
        console.error(error_);
      } finally {
        setIsLoading(false);
      }
    }

    if (!skipFetch && id) {
      fetchData();
    }

    return () => abortController && abortController.abort();
  }, [id, refetchIndex]);

  return { report, isLoading, error, refetch };
};
